"use strict";

exports.__esModule = true;
exports.PlantStateActivityEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _reactFinalFormArrays = require("react-final-form-arrays");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Form = require("../../Form");
var _PlantStateTag = require("../PlantStateTag");
var _Core = require("../../Core");
var _UserActions = require("../../UserActions");
var _System = require("../../../System");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _inputValidation = require("../../../Utils/inputValidation");
var _dec, _class, _PlantStateActivityEditor;
/* eslint-disable linebreak-style */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "PlantStateActivityEditor__EditorBody",
  componentId: "sc-b4klvu-0"
})(["padding:1rem;flex:1;display:flex;flex-direction:column;"]);

/**
 * Plant state activity editor form
 */
var PlantStateActivityEditor = exports.PlantStateActivityEditor = (_dec = _DeviceListContext.DeviceListContext.withContext, _dec(_class = (0, _Core.withTranslator)(_class = (0, _userActionsContext.withUserActionsContext)(_class = (_PlantStateActivityEditor = /*#__PURE__*/function (_Component) {
  function PlantStateActivityEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.validateName = function (value, allValues, meta) {
      var translator = _this.props.translator;
      var translate = translator.translate;
      if (!value || !value.trim()) {
        return translate("PlantStateActivityEditor.validateName.required", "Name is required.");
      }
      if ((0, _inputValidation.isUnmodified)(meta)) {
        return undefined;
      }
      return (0, _inputValidation.translateValidationError)((0, _inputValidation.validateEntityName)(value), translate);
    };
    return _this;
  }
  _inheritsLoose(PlantStateActivityEditor, _Component);
  var _proto = PlantStateActivityEditor.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      pristine = _this$props.pristine,
      invalid = _this$props.invalid,
      create = _this$props.create,
      translate = _this$props.translator.translate,
      userActions = _this$props.userActions,
      devices = _this$props.devices;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "submit-btn",
      intent: _core.Intent.PRIMARY,
      icon: _icons.IconNames.FLOPPY_DISK,
      type: "submit",
      text: translate("PlantStateActivityEditor.toolbar.saveButton.text", "Save"),
      disabled: pristine || invalid
    }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      exact: true,
      to: (0, _System.getScreenLocation)("PlantStateActivities"),
      minimal: true,
      icon: _icons.IconNames.CROSS,
      text: translate("PlantStateActivityEditor.toolbar.cancelButton.text", "Cancel")
    }))), /*#__PURE__*/_react["default"].createElement(EditorBody, {
      style: {
        overflow: "auto",
        height: "calc(100% - 48px)"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
      level: "3"
    }, translate("PlantStateActivityEditor.details.label", "Details")), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "name",
      label: translate("PlantStateActivityEditor.name.label", "Name"),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
      validate: this.validateName
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup
      // eslint-disable-next-line jsx-a11y/no-autofocus
      , _extends({
        autoFocus: true,
        "data-testid": "activity-name",
        style: {
          width: 300
        }
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "description",
      label: translate("PlantStateActivityEditor.description.label", "Description")
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
        "data-testid": "activity-description",
        fill: true,
        rows: 6
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_Form.FormGroupField, {
      name: "isEnabled",
      type: "checkbox"
    }, function (_ref3) {
      var input = _ref3.input;
      return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
        "data-testid": "isEnabled",
        label: translate("PlantStateActivityEditor.isEnabled.label", "Enabled")
      }, input, {
        checked: create ? true : input.checked
      }));
    }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      name: "stateClassifications",
      label: /*#__PURE__*/_react["default"].createElement("h4", null, translate("PlantStateActivityEditor.stateClassification.label", "States"))
    }, /*#__PURE__*/_react["default"].createElement("dl", null, /*#__PURE__*/_react["default"].createElement(_reactFinalFormArrays.FieldArray, {
      name: "states"
    }, function (_ref4) {
      var fields = _ref4.fields;
      return fields.map(function (fieldName) {
        return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
          key: fieldName,
          name: fieldName
        }, function (_ref5) {
          var state = _ref5.input.value;
          return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
            name: fieldName + ".active",
            type: "checkbox"
          }, function (_ref6) {
            var checkboxInput = _ref6.input;
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("dt", null, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
              "data-testid": state.id,
              label: /*#__PURE__*/_react["default"].createElement(_PlantStateTag.PlantStateTag, {
                large: true,
                label: state.name,
                stateId: state.id
              })
            }, checkboxInput))), /*#__PURE__*/_react["default"].createElement("dd", null, checkboxInput.checked && /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
              name: fieldName + ".userAction"
            }, function (_ref7) {
              var input = _ref7.input;
              return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
                label: translate("PlantStateActivityEditor.userAction.userActionType.label", "Action"),
                helperText: translate("PlantStateActivityEditor.userAction.userActionType.helperText", "The action to perform when classifying a cycle with this state / activity.")
              }, /*#__PURE__*/_react["default"].createElement(_UserActions.UserActionSelector, {
                items: userActions,
                selected: input.value ? [input.value.name] : [],
                toggle: true,
                onSelect: function onSelect(selected) {
                  return input.onChange(selected.length === 0 ? undefined : selected[0]);
                }
              })), input.value && /*#__PURE__*/_react["default"].createElement(_UserActions.UserActionFields, {
                userActions: userActions.userActions,
                config: input.value,
                onChange: input.onChange
              }));
            })));
          });
        });
      });
    })), /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
      name: "selectedDevices"
    }, function (_ref8) {
      var input = _ref8.input;
      return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("PlantStateActivity.devices.label", "Devices"),
        labelFor: "selectedDevices"
      }, /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
        style: {
          maxWidth: 500
        },
        devices: devices,
        tags: [],
        selected: input.value || [],
        onSelect: function onSelect(selected) {
          return input.onChange(selected.map(function (device) {
            return typeof device === "string" ? device : device.uuid;
          }));
        }
      }));
    }))));
  };
  return PlantStateActivityEditor;
}(_react.Component), _PlantStateActivityEditor.defaultProps = {
  translator: undefined,
  userActions: undefined,
  devices: undefined
}, _PlantStateActivityEditor)) || _class) || _class) || _class);